import http from '../../http'
import { API_URL } from '../../const'

export const getDashboard = () => http.get(`${API_URL}/DashboardPage/getData`)
